<div id="experiencias" class="experiencias">
  <div class="experiencias__header">
    <div class="div__subtitle_momentos">
      <p class="experiencias__subtitulo">
        Acumule cacaus e resgate momentos especiais!
      </p>
      <a (click)="irParaMomentosEspeciais()" class="lbl__link"
        >Descubra todos &nbsp;
        <svg
          class="icone__entenda"
          width="10"
          height="13"
          viewBox="0 0 10 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 15.1016L8 8.76956L2 2.4375"
            stroke="#841702"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </a>
    </div>
  </div>
  <div class="experiencias__container">
    <div class="container__restantes" *ngIf="exibirProgressoProximoNivel()">
      <div class="restantes__progresso">
        <div class="progresso__bg"></div>
        <div
          class="progresso__valor"
          [ngStyle]="calcularPorcentagemProximoNivel()"
        ></div>
      </div>

      <p class="pontos__restantes">
        Faltam
        <span class="lovers-font--color lovers-font--bold">
          {{ pontuacaoRestanteProximoNivel }} pontos
        </span>
        para desbloquear esse nível!
      </p>
    </div>

    <div
      [ngClass]="{
        'experiencias--sem-progresso': !exibirProgressoProximoNivel()
      }"
      class="container__experiencias"
      *ngIf="!carregandoExperiencias && this.experiencias.length > 0"
      #exp
      (mousedown)="startDragging($event, false, exp)"
      (mouseup)="stopDragging($event, false)"
      (mouseleave)="stopDragging($event, false)"
      (mousemove)="moveEvent($event, exp)"
    >
      <app-card-experiencia
        *ngFor="let experiencia of filtroExperiencias()"
        [id]="experiencia.id"
        [idGrupo]="experiencia.idGrupo"
        [preco]="experiencia.precoEmCacaus"
        [imagemSrc]="experiencia.imagemSrc"
        [titulo]="experiencia.nome"
        [descricao]="experiencia.descricao"
        [validade]="experiencia.dataFim"
        [nivel]="nivelSelecionadoDescricao"
        [idNivelExperiencia]="experiencia.idNivel"
        [idNivelMembro]="idMembro"
        [quantidadeDisponivel]="experiencia.quantidadeDisponivel"
        [tag]="experiencia.tag"
        [destaque]="experiencia.destaque"
        [niveis]="experiencia.experienciaNiveis"
        [nomeIdentificador]="experiencia.nomeIdentificador"
      ></app-card-experiencia>
    </div>

    <div
      class="container__experiencias experiencias__loader loader--desktop"
      *ngIf="carregandoExperiencias"
    >
      <div
        class="experiencias__experiencia"
        *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]"
      >
        <ngx-skeleton-loader
          [theme]="{
            'border-radius': '24px',
            width: '213px',
            height: '338px',
            display: 'block'
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>

    <div
      class="container__experiencias experiencias__loader loader--mobile"
      *ngIf="carregandoExperiencias"
    >
      <div class="experiencias__experiencia" *ngFor="let i of [1, 2, 3]">
        <ngx-skeleton-loader
          [theme]="{
            'border-radius': '24px',
            width: '164px',
            height: '244px',
            display: 'flex'
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</div>
